import React from "react";

const RefundPolicy = () => {
  return (
    <div className="max-w-4xl mx-auto px-6 py-10 text-gray-800">
      <h1 className="text-4xl font-bold text-center mb-8">
        Refund & Security Deposit Policy
      </h1>

      <section className="space-y-8 text-sm leading-relaxed">
        {/* Intro */}
        <p>
          This Refund & Security Deposit Policy (“Policy”) governs all
          transactions made on SurveysIQ (“Platform,” “we,” “us,” or “our”). By
          accessing or using our services, you agree to this Policy, along with
          our Terms of Service and Privacy Policy.
        </p>

        {/* General Refund Policy */}
        <div>
          <h2 className="text-2xl font-bold mb-3">General Refund Policy</h2>
          <ol className="list-decimal pl-6 space-y-2">
            <li>
              Refunds are available only in cases where the service purchased is
              defective, inaccessible, or not delivered as promised.
            </li>
            <li>
              To request a refund, you must:
              <ul className="list-disc pl-6 mt-1 space-y-1">
                <li>
                  Contact our customer support at{" "}
                  <a
                    href="mailto:help@surveysiq.com"
                    className="text-green-600"
                  >
                    help@surveysiq.com
                  </a>{" "}
                  within 7 (seven) days of the date of purchase.
                </li>
                <li>
                  Provide details of the issue along with relevant supporting
                  documents/screenshots, if applicable.
                </li>
              </ul>
            </li>
            <li>
              Our team will review your request and respond within 48 hours.
            </li>
            <li>
              If your request is approved, the refund will be processed within 7
              (seven) working days to the original payment method used.
            </li>
          </ol>
        </div>

        {/* Security Deposit Refund Policy */}
        <div>
          <h2 className="text-2xl font-bold mb-3">
            Security Deposit Refund Policy
          </h2>
          <ol className="list-decimal pl-6 space-y-2">
            <li>
              Certain services may require a refundable security deposit as
              specified at the time of purchase.
            </li>
            <li>
              Refund of the deposit will be subject to:
              <ul className="list-disc pl-6 mt-1 space-y-1">
                <li>
                  Deduction of a 10% annual service charge (plus applicable GST
                  @18%).
                </li>
                <li>Compliance with the terms of use of the Platform.</li>
              </ul>
            </li>
            <li>
              Refund requests must be made by the original depositor, supported
              with valid proof of identity and payment.
            </li>
            <li>
              If the security deposit refund is not claimed within 10 years from
              the date of deposit:
              <ul className="list-disc pl-6 mt-1 space-y-1">
                <li>The amount shall be deemed forfeited.</li>
                <li>
                  Forfeited deposits will be used for platform maintenance and
                  operational expenses, in compliance with applicable Indian tax
                  and accounting laws.
                </li>
                <li>
                  After the 10-year period, no refund claims will be entertained
                  under any circumstances.
                </li>
              </ul>
            </li>
          </ol>
        </div>

        {/* Method of Refund */}
        <div>
          <h2 className="text-2xl font-bold mb-3">Method of Refund</h2>
          <ol className="list-decimal pl-6 space-y-2">
            <li>
              Approved refunds will be issued only to the original payment
              method (e.g., bank account, UPI, wallet, or card) used at the time
              of purchase.
            </li>
            <li>
              Processing time may vary depending on your bank/payment provider
              but will generally take 7–10 working days.
            </li>
            <li>
              We are not responsible for delays caused by third-party payment
              processors, but we will provide reference details (UTR/transaction
              ID) for tracking.
            </li>
          </ol>
        </div>

        {/* Contact */}
        <div>
          <h2 className="text-2xl font-bold mb-3">Contact Us</h2>
          <p>
            If you have any questions, disputes, or clarifications regarding
            this Policy, please contact us at:{" "}
            <a href="mailto:help@surveysiq.com" className="text-green-600">
              help@surveysiq.com
            </a>
          </p>
        </div>
      </section>
    </div>
  );
};

export default RefundPolicy;
